import { matchPath } from 'react-router';

function isMatchLabPath(pathname: string, path: string, exact: boolean) {
    return Boolean(matchPath(pathname, { path, exact }));
}

export function mapMatchPath<T extends Record<string, string>>(
    urlsConfig: T,
    pathname: string,
    exact = false
): { [key in keyof T]: boolean } {
    return Object.fromEntries(
        Object.entries(urlsConfig).map(([key, value]) => {
            return [key, isMatchLabPath(pathname, value, exact)];
        })
    ) as { [key in keyof T]: boolean };
}
